<template>
  <div id="app">
    <!-- Шапка видна только гостям -->
    <HeaderComponent v-if="!isAuthenticated" />

    <!-- Основной лэйаут -->
    <div class="layout-container">
      <SideBar />
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from './components/HeaderComponent.vue';
import SideBar from './components/SideBar.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: { HeaderComponent, SideBar },
  setup() {
    const store = useStore();
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    return { isAuthenticated };
  }
};
</script>

<style scoped>
.layout-container {
  display: flex;
  flex-direction: row;   /* явно строкой */
  flex-wrap: nowrap;     /* запрет переносов */
  flex: 1 1 auto;
  height: 100%;          /* чтобы занять оставшуюся высоту под шапкой (если есть) */
  min-height: 0;         /* чтобы корректно работали скроллы внутри */
  overflow: visible;      /* как и было */
}
.content {
  flex: 1 1 auto;        /* занимать всё оставшееся */
  min-width: 0;          /* важно: иначе контент может «выталкивать» сайдбар */
  overflow: visible;
  padding-left: 0;
  padding-right: 0;
  padding-top: 2px;
}
</style>